<template>
   <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 90 90"
    >
    <path fill="#DD0F17" d="M97.44 68.27L87.2 74.02l-8.06-3.62a8.45 8.45 0 01-5-7.71l.04-32.96 23.27 38.54z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#DD0F17" d="M74.17 29.66l13 44.38 10.28-5.76-23.28-38.62z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#C60E15" d="M79.2 70.5l7.97 3.54-13-44.38v33.12a8.45 8.45 0 005.03 7.72z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#DD0F17" d="M1.4 9.17l10.52-5.71 7.83 3.48a8.45 8.45 0 015.01 7.72V47.5L1.41 9.17z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#C60E15" d="M24.76 47.51L11.92 3.46 1.41 9.17l23.35 38.34z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#DD0F17" d="M19.75 6.94l-7.83-3.48L24.75 47.5l.01-32.84a8.45 8.45 0 00-5.01-7.72z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#DD0F17" d="M60.55 68.27L50.3 74.09l-7.98-3.53a8.45 8.45 0 01-5.02-7.72V29.7l23.25 38.56z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#DD0F17" d="M37.28 29.67l13 44.38 10.28-5.76-23.28-38.62z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#C60E15" d="M42.3 70.52l7.99 3.53-13.01-44.38V62.8a8.45 8.45 0 005.03 7.72z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#DD0F17" d="M38.01 9.17l10.51-5.72 7.84 3.5a8.45 8.45 0 015 7.71v32.86L38 9.17z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#C60E15" d="M61.36 47.51L48.52 3.46 38.01 9.17l23.35 38.34z" clip-rule="evenodd" fill-rule="evenodd"></path>
    <path fill="#DD0F17" d="M56.35 6.94l-7.83-3.48L61.36 47.5V14.66a8.45 8.45 0 00-5-7.72z" clip-rule="evenodd" fill-rule="evenodd"></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'NacelleLogoIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
